import React from "react";
import './c27_cosa_imparerai.scss';
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import { isMobileOnly } from "react-device-detect";
import {insertHtml} from "../../utils/dom";

class CosaImparerai extends TemplateComponent {

    componentRender(data) {
        let classFields = data.class_fields;

        const leftArray = [];
        const rightArray = [];
        classFields.map(element => (element.side === "Left") && leftArray.push(element));
        classFields.map(element => (element.side === "Right") && rightArray.push(element));

        return (
            <div id="cosa-imparerai">
                {data.title ? <div className={!isMobileOnly ? 'cosa-imparerai-title' : 'cosa-imparerai-title-mob'}>{data.title}</div> : null}
                {data.subtitle ? <div className={!isMobileOnly ? 'cosa-imparerai-subtitle' : 'cosa-imparerai-subtitle-mob'}>{data.subtitle}</div> : null}
                {data.description ? <div className={!isMobileOnly ? 'cosa-imparerai-description' : 'cosa-imparerai-description-mob'} {...insertHtml(data.description)} /> : null}

                <div className="container-fluid classfield-container">
                    <div className="row">
                        <div className="col">
                            <ul className={!isMobileOnly ? 'classfield-list' : 'mob-classfield-list'}>
                                {leftArray ? leftArray.map((classField, index) => (
                                    <div key={index} className="">
                                        <li>
                                            <div className={!isMobileOnly ? 'classfield-title' : 'classfield-title-mob'}>{classField.title}</div>
                                            <div className={!isMobileOnly ? 'classfield-description' : 'classfield-description-mob'} {...insertHtml(classField.description)} />
                                        </li>
                                    </div>
                                )) : null}
                            </ul>
                        </div>
                        <div className="col">
                            <ul className={!isMobileOnly ? 'classfield-list' : 'mob-classfield-list'}>
                                {rightArray ? rightArray.map((classField, index) => (
                                    <div key={index} className="">
                                        <li>
                                            <div className={!isMobileOnly ? 'classfield-title' : 'classfield-title-mob'}>{classField.title}</div>
                                            <div className={!isMobileOnly ? 'classfield-description' : 'classfield-description-mob'} {...insertHtml(classField.description)} />
                                        </li>
                                    </div>
                                )) : null}
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

export default CosaImparerai;
